var BlurBackground = function(options) {
  var self = this;
  var defaults = {
    source: '.blur-bg__image',
    canvas: '.blur-bg__canvas',
    blur: 50
  };

  this.settings = $.extend({}, defaults, options);

  if (typeof self.settings.canvas == 'string') {
    this.canvas = $(self.settings.canvas).get(0);
  } else if (typeof self.settings.canvas === 'object') {
    this.canvas = self.settings.canvas.get(0);
  }

  this.canvasContext = self.canvas.getContext('2d');
  this.canvasSize = {
    w: self.canvas.width,
    h: self.canvas.height
  };
  this.container = $(self.canvas).parent();

  this.image = new Image();
  this.image.addEventListener("load", function() {
    display();
  }, false);

  if (typeof self.settings.canvas == 'string') {
    this.image.src = $(self.settings.source).get(0).src;
  } else if (typeof self.settings.canvas == 'object') {
    this.image.src = self.settings.source.get(0).src;
  }
  this.ratio = self.image.width / self.image.height;

  this.resizeTimer = null;

  /**
   * By Ken Fyrstenberg Nilsen
   *
   * drawImageProp(context, image [, x, y, width, height [,offsetX, offsetY]])
   *
   * If image and context are only arguments rectangle will equal canvas
  */
  var drawImageProp = function(ctx, img, x, y, w, h, offsetX, offsetY) {

    if (arguments.length === 2) {
      x = y = 0;
      w = ctx.canvas.width;
      h = ctx.canvas.height;
    }

    // default offset is center
    offsetX = typeof offsetX === "number" ? offsetX : 0.5;
    offsetY = typeof offsetY === "number" ? offsetY : 0.5;

    // keep bounds [0.0, 1.0]
    if (offsetX < 0) offsetX = 0;
    if (offsetY < 0) offsetY = 0;
    if (offsetX > 1) offsetX = 1;
    if (offsetY > 1) offsetY = 1;

    var iw = img.width,
        ih = img.height,
        r = Math.min(w / iw, h / ih),
        nw = iw * r,   // new prop. width
        nh = ih * r,   // new prop. height
        cx, cy, cw, ch, ar = 1;

    // decide which gap to fill
    if (nw < w) ar = w / nw;
    if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;  // updated
    nw *= ar;
    nh *= ar;

    // calc source rectangle
    cw = iw / (nw / w);
    ch = ih / (nh / h);

    cx = (iw - cw) * offsetX;
    cy = (ih - ch) * offsetY;

    // make sure source rectangle is valid
    if (cx < 0) cx = 0;
    if (cy < 0) cy = 0;
    if (cw > iw) cw = iw;
    if (ch > ih) ch = ih;

    // fill image in dest. rectangle
    ctx.drawImage(img, cx, cy, cw, ch,  x, y, w, h);
  };

  var outputImage = function(){
    drawImageProp(self.canvasContext, self.image);
  };

  var blur = function(canvas) {
    try {
        StackBlur.canvasRGB(self.canvas, 0, 0, self.container.width(), self.container.height(), self.settings.blur);
    }
    catch (e) {
        console.warn(e);
    }
  };

  var display = function() {
    $(self.canvas).attr('width', self.container.width() );
    $(self.canvas).attr('height', self.container.height() );

    if (self.image.height != 0) {
      outputImage();
      blur();
    } else {
      setTimeout(function(){
        display();
      }, 100);
    }
  };

  var resize = function() {
    self.resizeTimer = null;
    self.resizeTimer = setTimeout(function(){
      display();
    }, 200);
  };

  return {
    resize: resize
  };
};
